var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import tiktok from '@bridge/tiktok';
import { queryParamsFromGlobal, isRN, appVersion, isIOS } from '@lib/env_detect';
import DataBus from '@lib/data_bus';
import { stringify } from 'querystring';
import { CreateModel } from '@src/pages/delivery/const';
import compatibleSlardar from '../slardar';
import { waitForEvent } from '@src/utils/event';
import { retry, wait } from '@src/utils/promise';
/** 页面接收的所有参数 */
export var pageProps = {};
var internalParams = [
    'reactId',
    'closeReactId',
    'useDarkMode',
    'popGesture',
    'dev',
    'dynamic',
    'module_name',
    'fallback_url',
    'bundle_url',
    'show_close_button',
    'hide_back_button',
    'hide_nav_bar',
    'needShareBridge',
    'channel',
    'bundle',
    'rootTag',
    'force_h5',
];
export var initialPageProps = function (props) {
    Object.assign(pageProps, __assign(__assign(__assign({}, props), queryParamsFromGlobal), { reactId: props.reactId || window.reactId }));
    if (!pageProps.originParams) {
        var queries_1 = {};
        Object.entries(pageProps).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (internalParams.includes(key)) {
                return;
            }
            queries_1[key] = value;
        });
        pageProps.originParams = JSON.stringify(queries_1);
    }
    return pageProps;
};
/** key 为 RN 版本的 module name，value 为 lynx 版本 module name */
var lynxModuleNameMap = {
    promote_center: 'promote-center',
    delivery: 'delivery',
    direct_delivery: 'delivery',
    coupon_list: 'coupon-list',
    video_list: 'video-list',
    order_fail: 'order-fail',
    put_fail: 'put-fail',
};
function redirectFail(message) {
    compatibleSlardar.customReport('redirect_lynx', {
        status: 'fail',
        message: message,
    });
}
function waitForPageDisappear() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, waitForEvent(function (cb) {
                    var listener = function () {
                        if (document.hidden) {
                            cb(null);
                        }
                    };
                    document.addEventListener('visibilitychange', listener);
                    return function () { return document.removeEventListener('visibilitychange', listener); };
                })];
        });
    });
}
export function tryRedirectLynx() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var settings, promote_base_schema, module_name, pageModule, query, schema_1, error_1;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    // 低版本不重定向
                    if (appVersion < 216000) {
                        return [2 /*return*/, redirectFail("version " + appVersion)];
                    }
                    return [4 /*yield*/, tiktok.x.getSettings({ keys: [{ key: 'promote_base_schema', type: 'string' }] })];
                case 1:
                    settings = _b.sent();
                    promote_base_schema = ((_a = settings === null || settings === void 0 ? void 0 : settings.data) === null || _a === void 0 ? void 0 : _a.settings).promote_base_schema;
                    if (!promote_base_schema) {
                        return [2 /*return*/, redirectFail('no promote_base_schema')];
                    }
                    module_name = isRN
                        ? pageProps.module_name.replace('page_', '')
                        : location.pathname.replace('/falcon/forest/promote/', '');
                    pageModule = lynxModuleNameMap[module_name] || module_name;
                    if (!pageModule) {
                        return [2 /*return*/, redirectFail("module_name " + module_name)];
                    }
                    query = __assign(__assign({}, pageProps), { pageModule: pageModule, from_rn_redirect: 1 });
                    if (module_name === 'direct_delivery') {
                        query.createModel = CreateModel.Direct;
                    }
                    schema_1 = promote_base_schema + '&' + stringify(query);
                    retry(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    tiktok.x.open({ schema: schema_1, replace: true, animated: false });
                                    if (!isIOS) return [3 /*break*/, 2];
                                    return [4 /*yield*/, wait(500)];
                                case 1:
                                    _a.sent();
                                    if (!document.hidden) {
                                        throw new Error('跳转失败');
                                    }
                                    _a.label = 2;
                                case 2:
                                    compatibleSlardar.customReport('redirect_lynx', {
                                        status: 'success',
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); }, 5, 0)();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    compatibleSlardar.customReport('redirect_lynx', {
                        status: 'fail',
                        error: error_1,
                        message: error_1 === null || error_1 === void 0 ? void 0 : error_1.message,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export var loadPageCb = function (_a) {
    var reactId = _a.reactId, module_name = _a.module_name, fallback_url = _a.fallback_url, useDarkMode = _a.useDarkMode, popGesture = _a.popGesture, bundle_url = _a.bundle_url, dev = _a.dev, dynamic = _a.dynamic, closeReactId = _a.closeReactId, props = __rest(_a, ["reactId", "module_name", "fallback_url", "useDarkMode", "popGesture", "bundle_url", "dev", "dynamic", "closeReactId"]);
    DataBus.setReactId(reactId);
    tryRedirectLynx();
};
